import PropTypes from "prop-types";
import getConfig from "../../config";

const Icon = ({ id, className, ariaLabel }) => {
  const { symbolsSpriteUrl } = getConfig();
  return (
    <svg
      className={className}
      aria-label={ariaLabel || undefined}
      aria-hidden={!ariaLabel ? "true" : undefined}
    >
      <use href={`${symbolsSpriteUrl}#${id}`} />
    </svg>
  );
};

Icon.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default Icon;
